import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//App setup - Get All
export const GetAll = createAsyncThunk(
  "customizations/appsetup/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Customizations.AppSetup}?email=${filter?.email || ""}
        &contact_no=${filter?.contact_no || ""}&name=${filter?.name || ""}
        &page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// App setup - Get Single
export const GetSingle = createAsyncThunk(
  "customizations/appsetup/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Customizations.AppSetup}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//App setup - Create
export const Create = createAsyncThunk(
  "customizations/appsetup/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Customizations.AppSetup, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//App Setup update
export const Update = createAsyncThunk(
  "customizations/appsetup/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Customizations.AppSetup}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//App setup - Delete
export const Delete = createAsyncThunk(
  "customizations/appsetup/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Customizations.AppSetup}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//App Setup  - Status
export const StatusAppSetup = createAsyncThunk(
  "customizations/appsetup/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Customizations.AppSetup}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "appsetup",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      //GET ALL
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // GET SINGLE
      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // CREATE
      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload?.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //UPDATE
      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const updated = action.payload?.data;
        const index = state.data.findIndex(
          (appsetup) => appsetup.id === updated?.id,
        );
        if (index !== -1) {
          state.data[index] = updated;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //DELETE
      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter(
          (appsetup) => appsetup.id !== action.payload,
        );
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // STATUS
      .addCase(StatusAppSetup.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusAppSetup.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const updated = action.payload?.data;
        const index = state.data.findIndex(
          (appsetup) => appsetup.id === updated?.id,
        );
        if (index !== -1) {
          state.data[index] = updated;
        }
      })
      .addCase(StatusAppSetup.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const {} = Slice.actions;

export default Slice.reducer;
